export default __webpack_public_path__ + "static/media/open_project_04.3139ef73.svg";